var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroup = function SvgGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 162,
    viewBox: "0 0 163 162",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h163v161.899H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.491 114.173-39.378 39.305H11v-39.305h42.491zm98.078 0v39.305h-58.7c-21.749 0-39.378-17.596-39.378-39.305h98.078zM92.876 9v41.819a57.948 57.948 0 0 1-17.01 41.006l-22.375 22.348V9h39.385zm48.374 0c5.696 0 10.313 4.609 10.313 10.294 0 5.685-4.617 10.293-10.313 10.293-5.696 0-10.313-4.608-10.313-10.293S135.554 9 141.25 9z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};
export default SvgGroup;